import doc                      from '@widesk-core/decorators/doc';
import NetworkServiceModel      from '@/models/NetworkServiceModel';
import ContactModel             from '@/models/services/network/ContactModel';
import ContactGroupModel        from '@/models/services/network/ContactGroupModel';

@doc.path('/contact_contact_groups/{?id}')
export default class ContactContactGroupModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
		"contact": id;
		"contactGroup": id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(ContactModel) declare contact: ContactModel;
	@doc.model(ContactGroupModel) declare contactGroup: ContactGroupModel;
}